import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page/login-page.component';
import { RequestAccessPageComponent } from './pages/request-access-page/request-access-page/request-access-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page/forgot-password-page.component';
import { TicketsResolver } from './core/services/ticket/tickets.resolver';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent},
  { path: 'login/:auth', component: LoginPageComponent },
  { path: 'requestaccess', component: RequestAccessPageComponent },
  { path: 'forgotpassword', component: ForgotPasswordPageComponent },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard-page/dashboard-page.module').then(module => module.DashboardPageModule),
    resolve: {
      ticketTypes: TicketsResolver
    }
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ /*enableTracing: true*/ })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
